import useApiManager from 'networking/ApiManager';
import React, { useEffect, useState, useRef } from 'react';
import {
  CommonAlert,
  CoreButton,
  CoreInputBox,
  CoreTextArea,
  Select2DropDown,
  TagSelectPicker,
  ReactSelect,
  Loader,
} from 'whealth-core-web/components';
import { useLocation, useParams } from 'react-router-dom';
import { DatePicker, Input, Modal, Button as RsuiteButton } from 'rsuite';
import { formulationData, splitArrData, splitArrObjData } from '../Helper';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import './quill.css';
import Select from 'react-select';
import './paf.css';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';
import { pdf } from '@react-pdf/renderer';
import OPDReportPDF from '../PrescriptionPdf/Content';
import PafPdfContent from '../PrescriptionPdf/PafPdfContent';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Button,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  LinearProgress,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableHead,
  RadioGroup,
  Radio,
  ToggleButtonGroup,
  ToggleButton,
  MenuItem,
  FormControl,
  FormGroup,
} from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


function EditPafForm(props) {
  const userData = useGetLoginUserDataQuery()?.data?.data || {};
  const {
    onSave,
    setErrors,
    errors,
    dynamicPerscriptionData,
    selectedDepartment,
    userRole,
    userDetails,
    setDynamicPerscriptionData,
    setAlertType,
    setIsShowAlert,
    isShowAlert,
    alertType,
    isNivanCareTeam,
    citiesList,
    pafUpdateStatus,
    pid,
    pafStatus
  } = props;
  const location = useLocation();
  const [fieldErrors, setFieldErrors] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [pms, setPms] = useState({
    vas_score: '',
    is_final: false,
    health_condition: [],
    previous_investigation_report: '',
    principal_complaints: '',
    pain_treatment_history: '',
    final_diagnosis: 0,
    next_checkin_date: null,
    drug_allergies: [],
    mdt_consults_advised: '',
    internal_note:'',
  });
  const [weight, setWeight] = useState(''); // in kg
  const [feet, setFeet] = useState('');
  const [inches, setInches] = useState('');
  const [bmi, setBmi] = useState(null);
  const [pdfModal, setPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  // PAF START
  const [paf,setPaf] = useState({date_time:"", panel:"",insurance_category:"",insurance_type:"",name:"",age:"",gender:"",mobile_number:"",occupation:"",city:"",height_feet:"",height_inch:"",weight:"",bmi:"",pulse:"",bp:"",pms:"",contact_hours:"",complaintsNotes:"",contact_window: [],activityLevel:"",habits: []});

  const [chiefComplaint , setChiefComplaint] = useState([{}]);
  const [lifeStyle , setLifeStyle] = useState([]);

  const steps = [
    "Edit PAF"
  ];
  
  const [currentStep, setCurrentStep] = useState(0);

  const [ComplaintSite, setComplaintSite] = useState([
    { name: "Head", key: "head_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Neck", key: "neck_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Shoulder", key: "shoulder_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Back", key: "back_pain", disablelr: true, center: false, duration: "", pain_days: "", painScore: null },
    { name: "Elbow", key: "elbow_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Wrist", key: "wrist_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Palm", key: "palm_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Hip", key: "hip_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Knee", key: "knee_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Ankle", key: "ankle_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Foot", key: "foot_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Heel", key: "heel_pain", left: false, right: false, duration: "", pain_days: "", painScore: null },
    { name: "Others", key: "other_pain", left: false, right: false, duration: "", pain_days: "", painScore: null }
  ]);
  

  const [duration,setDuration] = useState([
    // { value: '< 1 m', label: '< 1 m' },
    { value: '0 - 1 m', label: '0 - 1 m' },
    { value: '2 m', label: '2 m' },
    { value: '3 m', label: '3 m' },
    { value: '4 m', label: '4 m' },
    { value: '5 m', label: '5 m' },
    { value: '6 m', label: '6 m' },
    { value: '1 - 3 m', label: '1 - 3 m' },
    { value: '3 - 6 m', label: '3 - 6 m' },
    { value: '6 m -1 yr', label: '6 m -1 yr' },
    { value: '1 - 2 yr', label: '1 - 2 yr' },
    { value: '2 - 3 yr', label: '2 - 3 yr' },
    { value: '3 - 4 yr', label: '3 - 4 yr' },
    { value: '4- 5 yr', label: '4- 5 yr' },
    { value: '5 - 6 yr', label: '5 - 6 yr' },
    { value: '6 - 7 yr', label: '6 - 7 yr' },
    { value: '7 - 8 yr', label: '7 - 8 yr' },
    { value: '8 - 9 yr', label: '8 - 9 yr' },
    { value: '9 - 10 yr', label: '9 - 10 yr' },
    { value: '10 - 15 yr', label: '10 - 15 yr' },
    { value: '15+ yr', label: '15+ yr' }
  ]);

  const [painDays, setPainDays] = useState([
    { value: '1 d', label: '1 d' },
    { value: '2 d', label: '2 d' },
    { value: '3 d', label: '3 d' },
    { value: '4 d', label: '4 d' },
    { value: '5 d', label: '5 d' },
    { value: '6 d', label: '6 d' },
    { value: '7 d', label: '7 d' },
    { value: '8 d', label: '8 d' },
    { value: '9 d', label: '9 d' },
    { value: '10 d', label: '10 d' },
    { value: '11 d', label: '11 d' },
    { value: '12 d', label: '12 d' },
    { value: '13 d', label: '13 d' },
    { value: '14 d', label: '14 d' },
    { value: '15 d', label: '15 d' },
    { value: '16 d', label: '16 d' },
    { value: '17 d', label: '17 d' },
    { value: '18 d', label: '18 d' },
    { value: '19 d', label: '19 d' },
    { value: '20 d', label: '20 d' },
    { value: '21 d', label: '21 d' },
    { value: '22 d', label: '22 d' },
    { value: '23 d', label: '23 d' },
    { value: '24 d', label: '24 d' },
    { value: '25 d', label: '25 d' },
    { value: '26 d', label: '26 d' },
    { value: '27 d', label: '27 d' },
    { value: '28 d', label: '28 d' },
    { value: '29 d', label: '29 d' },
    { value: '30 d', label: '30 d' },
    { value: '31 d', label: '31 d' }
  ]);

  const [painScore , setPainScore] = useState([
    { value: 0, label: 0 },
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
    { value: 6, label: 6 },
    { value: 7, label: 7 },
    { value: 8, label: 8 },
    { value: 9, label: 9 },
    { value: 10 , label: 10 },
  ]);

  const queryParams = new URLSearchParams(location.search);
  const isViewModeFromUrl = queryParams.get("view") === "1";
  const [isEditMode, setIsEditMode] = useState(false);
  
  // Ref for Primary Pain Site section to enable auto-scroll on validation error
  const primaryPainSiteRef = useRef(null);
  
  // const [pafStatus, setPafStatus] = useState(0)
  const [onset, setOnset] = useState({
    onsetType: "",
    progressType: "",
    progressSpeed: ""
  });
  
  const [character, setCharacter] = useState([]);
  const [associatedComplaints, setAssociatedComplaints] = useState([]);
  
  const [radiationReferral, setRadiationReferral] = useState({
    radiation: { selected: false, text: "" },
    referral: { selected: false, text: "" }
  });
  
  const [healthConditions, setHealthConditions] = useState([]);
  const [healthConditionsOther, setHealthConditionsOther] = useState("");
  
  const [pastReports, setPastReports] = useState([]);
  const [pastReportsOther, setPastReportsOther] = useState("");
  // const [primaryPain, setPrimaryPain] = useState({pain_site:"",pain_score:"",duration:""})
  const [primaryPain, setPrimaryPain] = useState({
    pain_site: "",
    left: false,
    right: false,
    center: false,
    pain_score: "",
    duration: "",
    pain_days: ""
  });
  
  const [allergies, setAllergies] = useState({
    multi: [],
    none: false,
    otherText: ""
  });

  // 9. Relation of pain to factors
// const factorsList = [
//   "Standing", "Rest", "Walking", "Lifting Weight", "Mood", "Sleep",
//   "Morning Stiffness", "Climbing Stairs", "Bending Forward","Lifting hand/objects", "Lying Down",
//   "Exposure to Light", "Loud Sound", "Darkness", "Neck Movement",
//   "Night Pain", "Change of Posture", "Back Extension",
//   "Cross Legged Sitting"
// ];
const factorsList = ["Rest","Prolonged standing" , "Prolonged sitting","Walking",
  "Climbing stairs","Changing posture","Neck movement","Bright light/loud sound","Lifting hand/objects"];

const factorsList1 = [
 "Rest","Prolonged standing" , "Prolonged sitting","Walking","Climbing stairs"
];
const factorsList2 = [
 "Changing posture","Neck movement","Bright light/loud sound","Lifting hand/objects"
];

const feetOptions = [
  { label: "3 ft", value: 3 },
  { label: "4 ft", value: 4 },
  { label: "5 ft", value: 5 },
  { label: "6 ft", value: 6 },
  { label: "7 ft", value: 7 },
  { label: "8 ft", value: 8 }
];

const inchOptions = Array.from({ length: 12 }, (_, i) => ({
  label: `${i} in`,
  value: i
}));

const occupationOptions = [
  { label: "Student", value: "Student" },
  { label: "Homemaker", value: "Homemaker" },
  { label: "Office / Desk job (Corporate/IT/Admin/Finance/HR etc)", value: "Office / Desk job (Corporate/IT/Admin/Finance/HR etc)" },
  { label: "Teacher / Professor / Academic staff", value: "Teacher / Professor / Academic staff" },
  { label: "Healthcare worker (Doctor / Nurse / Paramedic / Therapist)", value: "Healthcare worker (Doctor / Nurse / Paramedic / Therapist)" },
  { label: "Business owner / Self-employed (Shop / Professional / Entrepreneur)", value: "Business owner / Self-employed (Shop / Professional / Entrepreneur)" },
  { label: "Sales / Marketing / Field job (Travelling job)", value: "Sales / Marketing / Field job (Travelling job)" },
  { label: "Driver / Delivery / Transport (Cab/Auto/Truck/Logistics)", value: "Driver / Delivery / Transport (Cab/Auto/Truck/Logistics)" },
  { label: "Skilled worker / Technician (Electrician / Plumber / Carpenter / Mechanic)", value: "Skilled worker / Technician (Electrician / Plumber / Carpenter / Mechanic)" },
  { label: "Factory / Manufacturing worker", value: "Factory / Manufacturing worker" },
  { label: "Construction / Labour / Helper", value: "Construction / Labour / Helper" },
  { label: "Hospitality and Retail Services", value: "Hospitality and Retail Services" },
  { label: "Retired", value: "Retired" },
  { label: "Others", value: "Others" }
];

const [painFactors, setPainFactors] = useState(
  factorsList.map((f) => ({
    name: f,
    aggravating: false,
    relieving: false
  }))
);

const [painFactorsOther, setPainFactorsOther] = useState("");
const getFactorIndex = (name) =>
  painFactors.findIndex((f) => f.name === name);





// 10. Medication History
const [medicationHistory, setMedicationHistory] = useState({
  anticoagulants: false,
  steroids: false,
  othersSelected: false,
  othersText: ""
});


// 11. Family History
// const [familyHistory, setFamilyHistory] = useState("");
const [familyHistory, setFamilyHistory] = useState({
  hasHistory: "",  // "yes" or "no"
  details: ""
});


// 12. Past Treatments
const [pastTreatments, setPastTreatments] = useState({
  none: false, // Add None option
  // pms: { consulted: false, procedure: false },
  pms: {
    selected: false,
    option: ""
  },
  physio: false,
  otc: false,
  surgeon: {
    selected: false,
    option: "" // Sx Prescribed | Sx not Prescribed | Sx Done
  },
  physician: false,
  altTreatments: false
});

const contactWindowOptions = [
  { label: "Morning", value: "Morning" },
  { label: "Afternoon", value: "Afternoon" },
  { label: "Evening", value: "Evening" }
];

  

  const updateComplaint = (index, field, value) => {
    setComplaintSite((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: value
      };
      return updated;
    });
  };

  // const activeZones = ComplaintSite.reduce((acc, item) => {
  //   if (item.left) acc.push(`${item.key}_left`);
  //   if (item.right) acc.push(`${item.key}_right`);
  //   if (item.center) acc.push(`${item.key}_center`);
  //   return acc;
  // }, []);
  const primaryKey = primaryPain.pain_site.toLowerCase().replace(/\s+/g, "_");
  const activeZones = [
    // Secondary Pain Zones
    ...ComplaintSite.reduce((acc, item) => {
      if (item.left) acc.push(`${item.key}_left`);
      if (item.right) acc.push(`${item.key}_right`);
      if (item.center) acc.push(`${item.key}_center`);
      return acc;
    }, []),
    
    // Primary Pain Zones
    ...(primaryKey
      ? [
          ...(primaryPain.left ? [`${primaryKey}_left`] : []),
          ...(primaryPain.right ? [`${primaryKey}_right`] : []),
          ...(primaryPain.center ? [`${primaryKey}_center`] : []),
        ]
      : []),
  ];
  // PAF END


  const duplicateId = location?.state?.id;
  let { id } = useParams();


  useEffect(() => {
    ApiClient.prescriptionDoctorList(id, 'doctor').then((res) => {
      setDoctorList(res.data);
    });
  }, []);



  const ApiClient = useApiManager();

  // PDF Generation Functions
  const closeModalPdf = () => {
    setPdfModal(!pdfModal);
  };

  const openModalPdf = async () => {
    if (!pdfModal) {
      setIsLoading(true);
      try {
        const res = await ApiClient.pafPdfDownload(id);
        console.log('PAF PDF response:', res);
        
        let blob, blobURL;
        
        if (res.data) {
          // Generate PDF blob using @react-pdf/renderer with PafPdfContent
          blob = await pdf(<PafPdfContent data={res.data} />).toBlob();
          blobURL = URL.createObjectURL(blob);
        } else {
          blob = new Blob([res.data], { type: 'application/pdf' });
          blobURL = URL.createObjectURL(blob);
        }
        
        setPdfUrl(blobURL);
        setPdfModal(!pdfModal);
        setIsLoading(false);
      } catch (err) {
        console.error('Error generating PAF PDF:', err);
        setIsLoading(false);
      }
    }
  };



  useEffect(() => {
    let data = dynamicPerscriptionData;

    if(data?.status){
      // setPafStatus(data?.status);
    }
    if (data?.paf) {
      setPaf(data?.paf);
      if(data?.paf?.height_feet){
        setFeet(data?.paf?.height_feet)
      }
      if(data?.paf?.height_inch){
        setInches(data?.paf?.height_inch)
      }
      if(data?.paf?.weight){
        setWeight(data?.paf?.weight)
      }
    }

    if(data?.complaint_site){
      setComplaintSite(data?.complaint_site)
    }
    if(data?.onset){
      setOnset(data?.onset)
    }
    if(data?.radiation_referral){
      setRadiationReferral(data?.radiation_referral)
    }
    if(data?.character_data){
      setCharacter(data?.character_data)
    }
    if(data?.associated_complaints){
      setAssociatedComplaints(data?.associated_complaints)
    }
    if(data?.health_conditions){
      setHealthConditions(data?.health_conditions)
    }
    if(data?.health_conditions_other){
      setHealthConditionsOther(data?.health_conditions_other)
    }
    if(data?.past_reports){
      setPastReports(data?.past_reports)
    }
    if(data?.past_reports_other){
      setPastReportsOther(data?.past_reports_other)
    }
    if(data?.allergies){
      setAllergies(data?.allergies)
    }
    if(data?.pain_factors_other){
      setPainFactorsOther(data?.pain_factors_other)
    }
    if(data?.pain_factors){
      setPainFactors(data?.pain_factors)
    }
    if(data?.medication_history){
      setMedicationHistory(data?.medication_history)
    }
    if(data?.family_history){
      setFamilyHistory(data?.family_history)
    }
    if(data?.past_treatments){
      setPastTreatments(data?.past_treatments)
    }
    if(data?.primary_pain){
      setPrimaryPain(data?.primary_pain)
    }

   
  }, []);

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" }
  ];

  const getGenderOption = (genderValue) => {
    if (!genderValue) return null;
  
    return genderOptions.find(
      g => g.value.toLowerCase() === genderValue.toLowerCase()
    ) || null;
  };

  const handleInputData = (state_name, name, data, isMulti = 0) => {
        setPaf((prevPms) => ({
          ...prevPms,
          [name]: data,
        }));
  };

  useEffect(() => {
    var inch = inches;
    if (inches == undefined || inches == '') {
      inch = 0;
    }
    console.log(weight, '=>', inch,feet);
    if (weight && feet) {
      const totalInches = parseFloat(feet) * 12 + parseFloat(inch);
      const heightInMeters = (totalInches * 2.54) / 100;
      const calculatedBmi = weight / heightInMeters ** 2;
      setPaf((prevVital) => ({
        ...prevVital,
        ['bmi']: calculatedBmi.toFixed(2),
      }));
    } else {
      setPaf((prevVital) => ({
        ...prevVital,
        ['bmi']: 0,
      }));
    }
  }, [weight, feet, inches]);

  const renderFormDetails = () => {
    let defaultDateValue = '';
    if (pms?.next_checkin_date) {
      let date = new Date(pms?.next_checkin_date);
      if (date != 'Invalid Date') {
        defaultDateValue = date;
      }
    }

    const handleNext = () => {
      console.log("currentStep",currentStep,steps.length)
      if (currentStep < steps.length - 1) setCurrentStep((prev) => prev + 1);
    };
  
    const handleBack = () => {
     
      if (currentStep > 0) setCurrentStep((prev) => prev - 1);
    };
    const complaintSiteOptions = ComplaintSite.map(site => ({
      label: site.name,
      value: site.name
    }));

    const insuranceList = [
      "Bajaj Allianz",
      "Cholamandalam MS General Insurance",
      "Ericson TPA Health Care Pvt. Ltd.",
      "East West Assist TPA Pvt. Ltd.",
      "Family Health Plan TPA (FHPL)",
      "Focus Health Pvt. Ltd",
      "Future Generali India Insurance",
      "Genins India TPA",
      "Good Health Plan TPA (GHPL)",
      "Health India TPA",
      "Health Insurance TPA",
      "Heritage Health TPA",
      "ICICI Prudential",
      "Alankit Health Care",
      "Acko With Mediassist & FHPL TPA",
      "IFFCO Tokio",
      "Liberty General Insurance",
      "MD India Health TPA",
      "Mediassist TPA",
      "Paramount TPA",
      "Park Mediclaim TPA",
      "Raksha TPA",
      "Safeway TPA",
      "United Healthcare Parekh TPA",
      "Vidal",
      "Health Care TPA",
      "Vipul Medcrop TPA",
      "Med Save Health Insurance Ltd.",
      "Reliance General Insurance",
      "Universal Sampoo",
      "SBI General Insurance",
      "Go Digit",
      "HDFC Insurance",
      "Care Health",
      "Star Health",
      "Aditya Birla insurance",
      "Niva Bupa Insurance",
      "Others"
    ];
    

    const isSiteSelected = (item) => {
      return item.left || item.right || item.center;
    };
    
    const validateBeforeSave = () => {
    
      let newErrors = {};
      let complaintValid = true;
    
      // ---------------- BASIC ----------------
      if (!paf?.name) newErrors.name = "Name required";
      if (!paf?.age || paf.age < 10 || paf.age > 110)
        newErrors.age = "Age must be 10 - 110";
    
      if (!paf?.mobile_number || !/^[6-9]\d{9}$/.test(paf.mobile_number))
        newErrors.mobile_number = "Valid 10 digit mobile required";
    
      if (!paf?.city) newErrors.city = "City required";
    
      // ---------------- INSURANCE ----------------
      if (paf?.insurance_category === "Govt" && !paf?.insurance_type) {
        newErrors.insurance_type = "Insurance Type is required";
      }
    
      // ---------------- BP ----------------
      if (paf?.bp) {
        const regex = /^\d{2,3}\/\d{2,3}$/;
        if (!regex.test(paf.bp)) {
          newErrors.bp = "BP must be like 120/80";
        } else {
          const [sys, dia] = paf.bp.split("/").map(Number);
          if (sys < 70 || sys > 250 || dia < 40 || dia > 150) {
            newErrors.bp = "BP out of range";
          }
        }
      }
    
      // ---------------- PULSE ----------------
      if (paf?.pulse && (paf.pulse < 30 || paf.pulse > 220)) {
        newErrors.pulse = "Pulse must be 30 - 220";
      }
    
      // ---------------- ONSET ----------------
      if (
        onset?.progressType === "Progressive" &&
        !onset?.progressSpeed
      ) {
        newErrors.progressSpeed = "Progress Speed is required";
      }


      // ---------------- PRIMARY PAIN VALIDATION ----------------

      if (primaryPain.pain_site) {
        const primaryKey = primaryPain.pain_site
          ?.toLowerCase()
          .replace(/\s+/g, "_");

        // Left / Right / Center required
        if (!primaryPain.left && !primaryPain.right && !primaryPain.center) {
          newErrors.primaryPainSide = "Select Left, Right or Center for Primary Pain";
          // setErrors(newErrors);
          // return;
        }

        // Duration required
        if (!primaryPain.duration) {
          newErrors.primaryPainDuration = "Duration required for Primary Pain";
          // setErrors(newErrors);
          // return;
        }

        // Pain Score required
        if (!primaryPain.pain_score && primaryPain.pain_score !== 0) {
          newErrors.primaryPainScore =  "Pain Score required for Primary Pain";
          // setErrors(newErrors);
          // return;
        }
      }
    
      // ---------------- RADIATION ----------------
      // if (
      //   radiationReferral?.radiation?.selected &&
      //   !radiationReferral?.radiation?.text?.trim()
      // ) {
      //   newErrors.radiation_text = "Radiation details required";
      // }
    
      // ---------------- REFERRAL ----------------
      // if (
      //   radiationReferral?.referral?.selected &&
      //   !radiationReferral?.referral?.text?.trim()
      // ) {
      //   newErrors.referral_text = "Referral details required";
      // }
    
      // ---------------- PAST REPORTS VALIDATION ----------------
      if (!pastReports || pastReports.length === 0) {
        newErrors.past_reports = "Past Reports field is required. Please select at least one option.";
      }

      // ---------------- PAST TREATMENTS VALIDATION ----------------
      const hasPastTreatment = pastTreatments.none || 
                               pastTreatments.pms.selected || 
                               pastTreatments.physio || 
                               pastTreatments.otc || 
                               pastTreatments.surgeon.selected || 
                               pastTreatments.physician || 
                               pastTreatments.altTreatments;
      
      if (!hasPastTreatment) {
        newErrors.past_treatments = "Past Treatments field is required. Please select at least one option.";
      }

      // ---------------- PRIMARY PAIN SITE VALIDATION ----------------
      if (!primaryPain.pain_site) {
        newErrors.primary_pain_site = "Primary Pain Site is required. Please select a pain site.";
        // Scroll to Primary Pain Site section
        setTimeout(() => {
          primaryPainSiteRef.current?.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
        }, 100);
      }

      // ---------------- SECONDARY PAIN TABLE ----------------
      const updatedComplaint = ComplaintSite.map((item) => {
        const siteSelected = isSiteSelected(item);
        const hasDuration = !!item.duration;
        const hasPainScore = !!item.painScore;
      
        let error = false;
      
        const groupFilled =
          siteSelected && hasDuration && hasPainScore;
      
        const groupEmpty =
          !siteSelected && !hasDuration && !hasPainScore;
      
        // If neither fully filled nor fully empty → error
        if (!groupFilled && !groupEmpty) {
          error = true;
          complaintValid = false;
        }
      
        return { ...item, error };
      });
      // const updatedComplaint = ComplaintSite.map(item => {
    
      //   if (isSiteSelected(item)) {
      //     if (!item.duration || !item.painScore) {
      //       complaintValid = false;
      //       return { ...item, error: true };
      //     }
      //   }
    
      //   return { ...item, error: false };
      // });
    
      setComplaintSite(updatedComplaint);
    
      if (!complaintValid) {
        newErrors.secondary_pain =
          "Fill Duration & Pain Score for selected pain sites";
      }
    
      // ---------------- APPLY ERRORS ----------------
      setErrors(newErrors);
    
      return Object.keys(newErrors).length === 0;
    };
    

    // render code  
    
    const PainFactorRow = ({ label, value, onChange }) => {
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 0.6,
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          {/* Left label */}
          <Typography sx={{ fontSize: 15, color: '#444', width: '65%' }}>
            {label}
          </Typography>
    
          {/* Right + / - buttons */}
          <Box display='flex' gap={1}>
            {/* PLUS BUTTON */}
            <Button
              type="button"   // 🔥 VERY IMPORTANT — STOPS SCROLL / FORM SUBMIT
              variant={value === '+' ? 'contained' : 'outlined'}
              onClick={() => onChange(value === '+' ? '' : '+')}
              sx={{
                minWidth: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: value === '+' ? '#1976d2' : '#f3f3f3',
                color: value === '+' ? '#fff' : '#555',
                borderColor: '#ddd',
                '&:hover': {
                  bgcolor: value === '+' ? '#1565c0' : '#e9e9e9',
                },
              }}
            >
              +
            </Button>
    
            {/* MINUS BUTTON */}
            <Button
              type="button"   // 🔥 VERY IMPORTANT — STOPS SCROLL / FORM SUBMIT
              variant={value === '-' ? 'contained' : 'outlined'}
              onClick={() => onChange(value === '-' ? '' : '-')}
              sx={{
                minWidth: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: value === '-' ? '#1976d2' : '#f3f3f3',
                color: value === '-' ? '#fff' : '#555',
                borderColor: '#ddd',
                '&:hover': {
                  bgcolor: value === '-' ? '#1565c0' : '#e9e9e9',
                },
              }}
            >
              –
            </Button>
          </Box>
        </Box>
      );
    };
    

    const renderStepContent = (step) => {
      console.log(step)
      switch (step) {
       
  
        case 0:
          return (
          <>
          {/* 0 */}
          <Typography color='text.secondary'>
              {/* Patient Info Bar */}
              {/* <Box
                  sx={{
                    background: 'linear-gradient(90deg, #7ea6e7, #334155)',
                    color: '#fff',
                    borderRadius: 2,
                    px: 3,
                    py: 2,
                    mb: 3,
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography>Patient: <b>{userDetails?.name}</b></Typography>
                  <Typography>Age: <b>{userDetails?.age}</b></Typography>
                  <Typography>Gender: <b>{userDetails?.gender}</b></Typography>
                </Box> */}

                {/* Basic Details  */}
                {/* -------- BASIC DETAILS -------- */}
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label='Patient Name'
                        value={paf?.name || ''}
                        onChange={(e) =>
                          handleInputData('paf', 'name', e.target.value)
                        }
                        error={!!errors.name}
                        helperText={errors.name || ""}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label='Age (Yrs)'
                        type="tel"
                        inputMode="numeric"
                        value={paf?.age || ''}
                        onChange={(e) =>
                          handleInputData('paf', 'age', e.target.value)
                        }
                        error={!!errors.age}
                        helperText={errors.age || ""}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        disabled={!isEditMode}
                        select
                        fullWidth
                        label="Gender"
                        value={paf?.gender || ""}
                        onChange={(e) => {
                          handleInputData("paf", "gender", e.target.value);
                        }}
                      >
                        {genderOptions.map(opt => (
                          <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {/* Date & Time */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        type='datetime-local'
                        label='Date & Time'
                        InputLabelProps={{ shrink: true }}
                        value={paf?.date_time || ''}
                        onChange={(e) => {
                          handleInputData('paf', 'date_time', e.target.value);
                        }}
                      />
                    </Grid>

                    {/* Panel */}
                    {/* <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label='Panel (If any)'
                        value={paf?.panel || ''}
                        onChange={(e) =>
                          handleInputData('paf', 'panel', e.target.value)
                        }
                      />
                    </Grid> */}

                    {/* Mobile Number */}
                    {!(userRole === 'doctor' || userRole === 'doctor_pms') && (
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        type="tel"
                        inputMode="numeric"
                        label='Mobile Number'
                        value={paf?.mobile_number || ''}
                        onChange={(e) =>{
                          const value = e.target.value.replace(/\D/g, ''); // only digits
                          if (value.length <= 10) {
                            handleInputData('paf', 'mobile_number', value)
                          }
                        }
                        }
                        error={!!errors.mobile_number}
                        helperText={errors.mobile_number || ""}
                      />
                    </Grid>
                    )}

                    {/* Contact Hours */}
                    {/* <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label='Contact Hours'
                        value={paf?.contact_hours || ''}
                        onChange={(e) =>
                          handleInputData('paf', 'contact_hours', e.target.value)
                        }
                      />
                    </Grid> */}
                    <Grid item xs={12} md={4}>
                        <Autocomplete
                          multiple
                          disabled={!isEditMode}
                          options={contactWindowOptions}

                          getOptionLabel={(opt) => opt.label}

                          value={
                            contactWindowOptions.filter(opt =>
                              paf?.contact_window?.includes(opt.value)
                            )
                          }

                          onChange={(e, selectedValues) => {
                            handleInputData(
                              "paf",
                              "contact_window",
                              selectedValues.map(v => v.value)
                            );
                          }}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              inputProps={{
                                ...params.inputProps,
                                readOnly: true   // ✅ prevents typing
                              }}
                              label="Contact Window"
                              fullWidth
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                          <Autocomplete
                            disabled={!isEditMode}
                            options={occupationOptions}
                            getOptionLabel={(opt) => opt.label}
  
                            value={
                              occupationOptions.find(
                                opt => opt.value === paf?.occupation
                              ) || null
                            }
  
                            onChange={(e, val) => {
                              handleInputData("paf", "occupation", val?.value || "");
                            }}
  
                            renderInput={(params) => (
                              <TextField {...params} label="Occupation" 
                              inputProps={{
                                ...params.inputProps,
                                readOnly: true   // ✅ prevents typing
                              }}
                              fullWidth />
                            )}
                          />
                        </Grid>
                        {paf?.occupation == "Others" && 
                            <Grid item xs={12} md={4}>
                              <TextField
                                disabled={!isEditMode}
                                fullWidth
                                label='Other Occupation'
                                value={paf?.other_occupation || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                    handleInputData('paf', 'other_occupation', value);
                                
                                }}
                                // required
                                InputLabelProps={{
                                  shrink: true,
                                  sx: {
                                    "& .MuiFormLabel-asterisk": {
                                      color: "red"
                                    }
                                  }
                                }}
                              />
                            </Grid>
                          }
                    {/* City */}
                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        disabled={!isEditMode}
                        options={citiesList || []}
                        getOptionLabel={(option) => option.label || option.title || option.name || ''}
                        value={
                          citiesList?.find((c) => c.value === paf?.city) || null
                        }
                        onChange={(event, selectedValue) => {
                          handleInputData('paf', 'city', selectedValue?.value || '');
                        }}
                        renderInput={(params) => (
                          <TextField
                            disabled={!isEditMode}
                            {...params}
                            label='City'
                            inputProps={{
                              ...params.inputProps,
                              readOnly: true   // ✅ prevents typing
                            }}
                            fullWidth
                            error={!!errors.city}
                            helperText={errors.city || ""}
                          />
                        )}
                      />
                    </Grid>
                    {paf?.city == "Other" && 
                      <Grid item xs={12} md={4}>
                        <TextField
                          disabled={!isEditMode}
                          fullWidth
                          label='Other City'
                          value={paf?.other_city || ''}
                          onChange={(e) => {
                            const value = e.target.value;
                              handleInputData('paf', 'other_city', value);
                          
                          }}
                          // required
                          InputLabelProps={{
                            shrink: true,
                            sx: {
                              "& .MuiFormLabel-asterisk": {
                                color: "red"
                              }
                            }
                          }}
                        />
                      </Grid>
                    }
                  </Grid>

                    {/* Insurance Category */}
                    <Box mt={5} mb={3}>
                      <Typography fontWeight={600}>Panel (If any)</Typography>
                      <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                    </Box>
                    <Grid container spacing={3}>
                    {/* Insurance Category */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        select
                        fullWidth
                        // required
                        label='Insurance Category'
                        value={paf?.insurance_category || ''}
                        onChange={(e) =>
                          setPaf((prev) => ({
                            ...prev,
                            insurance_category: e.target.value,
                            insurance_type : ''
                          }))
                        }
                        SelectProps={{ native: true }}
                      >
                        <option value=''></option>
                        <option value='Retail'>Retail</option>
                        <option value='Corporate'>Corporate</option>
                        <option value='Govt'>Govt</option>
                        <option value='Cash'>Cash</option>
                        <option value='NA'>NA</option>
                      </TextField>
                    </Grid>

                    {/* Insurance Type (only if Govt) */}
                    {paf?.insurance_category === 'Corporate' && (
                        <Grid item xs={12} md={4}>
                          <TextField
                            select
                            fullWidth
                            required
                            label='Insurance Type'
                            value={paf?.insurance_type || ''}
                            onChange={(e) => {
                              setPaf(prev => ({
                                ...prev,
                                insurance_type: e.target.value
                              }));
                          
                              setErrors(prev => ({
                                ...prev,
                                insurance_type: ""
                              }));
                            }}
                            SelectProps={{ native: true }}
                            InputLabelProps={{
                              shrink: true,
                              sx: {
                                "& .MuiFormLabel-asterisk": {
                                  color: "red"
                                }
                              }
                            }}
                            
                            error={!!errors.insurance_type}
                            helperText={errors.insurance_type || ""}
  
                          >
                            <option value=''></option>
                            {insuranceList.map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))}
                          </TextField>
                        </Grid>
                      )}
                    {paf?.insurance_category === 'Govt' && (
                      <Grid item xs={12} md={4}>
                        <TextField
                          select
                          fullWidth
                          required
                          label='Insurance Type'
                          value={paf?.insurance_type || ''}
                          onChange={(e) => {
                            setPaf(prev => ({
                              ...prev,
                              insurance_type: e.target.value
                            }));
                        
                            setErrors(prev => ({
                              ...prev,
                              insurance_type: ""
                            }));
                          }}
                          SelectProps={{ native: true }}
                          InputLabelProps={{
                            sx: {
                              "& .MuiFormLabel-asterisk": {
                                color: "red"
                              }
                            }
                          }}
                          
                          error={!!errors.insurance_type}
                          helperText={errors.insurance_type || ""}

                        >
                          <option value=''></option>
                          <option value='CGHS'>CGHS</option>
                          <option value='DGHS'>DGHS</option>
                          <option value='DJB'>DJB</option>
                          <option value='ECHS'>ECHS</option>
                          <option value='ESIC'>ESIC</option>
                          <option value='Ayushman'>Ayushman</option>
                          <option value='MCD'>MCD</option>
                        </TextField>
                      </Grid>
                    )}

                    {paf?.insurance_type == "Others" && 
                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          label='Other Insurance Type'
                          value={paf?.other_insurance_type || ''}
                          onChange={(e) => {
                            const value = e.target.value;
                              handleInputData('paf', 'other_insurance_type', value);
                          
                          }}
                          // required
                          InputLabelProps={{
                            shrink: true,
                            sx: {
                              "& .MuiFormLabel-asterisk": {
                                color: "red"
                              }
                            }
                          }}
                        />
                      </Grid>
                    }

                    </Grid>

            </Typography>
          {/* 1 */}
          <Typography color='text.secondary'>
            {/* -------- VITAL DATA -------- */}
                    <Box mt={5} mb={2}>
                    <Typography fontWeight={600}>Vitals</Typography>
                    <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                    </Box>

                    <Grid container spacing={3}>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label='BP'
                        value={paf?.bp || ''}
                        onChange={(e) =>
                          handleInputData('paf', 'bp', e.target.value)
                        }
                        error={!!errors.bp}
                        helperText={errors.bp || ""}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label='Pulse'
                        type="number"
                        inputMode="numeric"
                        value={paf?.pulse || ''}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === '' || val <= 220) {
                            handleInputData('paf', 'pulse', val)
                          }
                          
                        }}
                        // onChange={(e) =>
                        //   handleInputData('paf', 'pulse', e.target.value)
                        // }
                        error={!!errors.pulse}
                        helperText={errors.pulse || ""}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      {/* <TextField
                        fullWidth
                        label='Height (Feet)'
                        value={paf?.height_feet || ''}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === '' || (val >= 4 && val <= 8)) {
                            handleInputData('paf', 'height_feet', val);
                            setFeet(val);
                          }
                        }}
                      /> */}
                      <TextField
                          select
                          fullWidth
                          disabled={!isEditMode}
                          label="Height (Feet)"
                          value={paf?.height_feet || ""}
                          onChange={(e) => {
                            handleInputData("paf", "height_feet", e.target.value);
                            setFeet(e.target.value);
                          }}
                        >
                          {feetOptions.map(opt => (
                            <MenuItem key={opt.value} value={opt.value}>
                              {opt.label}
                            </MenuItem>
                          ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      {/* <TextField
                        fullWidth
                        label='Height (Inches)'
                        value={paf?.height_inch || ''}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === '' || val <= 12) {
                            handleInputData('paf', 'height_inch', val);
                            setInches(val);
                          }
                        }}
                      /> */}
                      <TextField
                          select
                          fullWidth
                          disabled={!isEditMode}
                          label="Height (Inches)"
                          value={paf?.height_inch}
                          onChange={(e) => {
                            handleInputData("paf", "height_inch", e.target.value);
                            setInches(e.target.value);
                          }}
                        >
                          {inchOptions.map(opt => (
                            <MenuItem key={opt.value} value={opt.value}>
                              {opt.label}
                            </MenuItem>
                          ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label='Weight (Kgs)'
                        type="number"
                        inputMode="numeric"
                        value={paf?.weight || ''}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === '' || val <= 200) {
                            handleInputData('paf', 'weight', val);
                            setWeight(val);
                          }
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        disabled
                        label='BMI'
                        value={paf?.bmi || ''}
                        InputProps={{
                          style: {
                            color:
                              paf?.bmi < 18.5 || paf?.bmi > 24.9 ? 'red' : 'green',
                            fontWeight: 600,
                          },
                        }}
                      />
                    </Grid>

                    </Grid>

                    {/* -------- COMPLAINT NOTES -------- */}
                    {/* <Box mt={5} mb={5}>
                    <label class='inputlabel'>Complaint Notes</label>
                    <ReactQuill
                      theme='snow'
                      // ref={principalRef}
                      value={paf.complaintsNotes}
                      onChange={(value) => setPaf((prevState) => ({ ...prevState, complaintsNotes: value }))}
                      // onKeyDown={(e) => handleQuillKeyDown(e, painRef)}
                    />
                    </Box> */}
                    <Box mt={5} mb={5}>
                        <div className='row'>
                          <div className='col-md-6'>
                            <label class='inputlabel'>Complaint Notes</label>
                            <ReactQuill
                              theme='snow'
                              readOnly={!isEditMode}
                              // ref={principalRef}
                              value={paf.complaintsNotes}
                              onChange={(value) => setPaf((prevState) => ({ ...prevState, complaintsNotes: value }))}
                              // onKeyDown={(e) => handleQuillKeyDown(e, painRef)}
                            />
                          </div>
                          <div className='col-md-6'>
                            <Box mt={0}>
                                <Typography fontWeight={600}>Lifestyle:</Typography>
                                <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                            </Box>
                            <div className='row'>
                              <div className='col-md-12'>
                                <FormControl>
                                {/* <FormLabel>Activity Level</FormLabel> */}
                                <Box mt={1}>
                                  <Typography fontWeight={600}>Activity Level :</Typography>
                                  <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                                </Box>
  
                                <RadioGroup
                                  row
                                  value={paf?.activityLevel}
                                  // onChange={(e) => setActivityLevel(e.target.value)}
                                  onChange={(e) => {
                                    setPaf(prev => ({
                                      ...prev,
                                      activityLevel: e.target.value
                                    }));
                                  }}
                                >
                                  <FormControlLabel value="Sedentary" control={<Radio />} label="Sedentary" />
                                  <FormControlLabel value="Active" control={<Radio />} label="Active" />
                                  <FormControlLabel value="Athletic" control={<Radio />} label="Athletic" />
                                </RadioGroup>
                              </FormControl>
                              </div>
                              <div className='col-md-12'>
  
                              <FormControl>
                                <Box mt={0}>
                                  <Typography fontWeight={600}>Habits:</Typography>
                                  <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                                </Box>
  
                                <FormGroup row>
                                  {["Smoking", "Alcohol"].map((habit) => (
                                    <FormControlLabel
                                      key={habit}
                                      control={
                                        <Checkbox
                                          checked={paf?.habits?.includes(habit)}
                                          onChange={(e) => {
                                            let updatedHabits = e.target.checked
                                              ? [...(paf.habits || []), habit]
                                              : (paf.habits || []).filter(h => h !== habit);
  
                                            setPaf(prev => ({
                                              ...prev,
                                              habits: updatedHabits
                                            }));
                                          }}
                                        />
                                      }
                                      label={habit}
                                    />
                                  ))}
                                </FormGroup>
                              </FormControl>
                              </div>
  
                            </div>
                            
                            
                          </div>
                        </div>
                      </Box>
  
                      {/* table start */}
                      <div style={{ border: "1px solid #ddd" }} className='mb-4'>
                        <div style={{ background: "#f5e6c8", padding: 8, fontWeight: 600 }}>
                          Pain Scale (0 – 10)
                        </div>
  
                        <div style={{ display: "flex" }}>
                          {[
                            { score: "0", text: "No pain", emoji: "😊" },
                            { score: "1-3", text: "Mild pain", emoji: "🙂" },
                            { score: "4-6", text: "Moderate pain", emoji: "😐" },
                            { score: "7-10", text: "Severe pain", emoji: "😣" }
                          ].map((item, i) => (
                            <div
                              key={i}
                              style={{
                                flex: 1,
                                borderRight: "1px solid #ddd",
                                padding: 5,
                                textAlign: "center"
                              }}
                            >
                              <div style={{ fontSize: 30 }}>{item.emoji}</div>
                              <div style={{ fontWeight: 600 }}>{item.score}</div>
                              <div>{item.text}</div>
                            </div>
                          ))}
                        </div>
                      </div>
  
                      {/* table end */}
                    {/* Primary Pain */}
                    <Box mb={2} ref={primaryPainSiteRef}>
                      <Typography fontWeight={600}>
                        Primary Pain Site <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                    </Box>
                     {/* PRIMARY */}
                    
                      <>
    
                      <Grid container spacing={3} alignItems="center">
    
                        {/* Pain Site */}
                        <Grid item xs={12} md={3}>
                          <Autocomplete
                            disabled={!isEditMode}
                            options={complaintSiteOptions || []}
                            getOptionLabel={(opt) => opt.label || ""}
                            value={
                              complaintSiteOptions.find(
                                (opt) => opt.value === primaryPain.pain_site
                              ) || null
                            }
                            onChange={(e, val) => {
                              setPrimaryPain(prev => ({
                                ...prev,
                                pain_site: val?.value || "",
                                left: false,
                                right: false,
                                center: false
                              }));
                              // Clear validation error
                              setErrors((prevErrors) => {
                                const { primary_pain_site, ...rest } = prevErrors;
                                return rest;
                              });
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Pain Site" 
                              inputProps={{
                                ...params.inputProps,
                                readOnly: true   // ✅ prevents typing
                              }}
                              size="small" />
                            )}
                          />
                        </Grid>
    
                        {/* LEFT CHECKBOX */}
                        {primaryPain.pain_site && primaryPain.pain_site !== "Back" && (
                          <Grid item xs={6} md={1}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={primaryPain.left}
                                  onChange={(e) =>
                                    setPrimaryPain(prev => ({
                                      ...prev,
                                      left: e.target.checked
                                    }))
                                  }
                                />
                              }
                              label="Left"
                            />
                          </Grid>
                        )}
    
                        {/* RIGHT CHECKBOX */}
                        {primaryPain.pain_site && primaryPain.pain_site !== "Back" && (
                          <Grid item xs={6} md={1}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={primaryPain.right}
                                  onChange={(e) =>
                                    setPrimaryPain(prev => ({
                                      ...prev,
                                      right: e.target.checked
                                    }))
                                  }
                                />
                              }
                              label="Right"
                            />
                          </Grid>
                        )}
    
                        {/* CENTER CHECKBOX ONLY FOR BACK */}
                        {primaryPain.pain_site === "Back" && (
                          <Grid item xs={12} md={2}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={primaryPain.center}
                                  onChange={(e) =>
                                    setPrimaryPain(prev => ({
                                      ...prev,
                                      center: e.target.checked
                                    }))
                                  }
                                />
                              }
                              label="Center"
                            />
                          </Grid>
                        )}
    
                        {/* Duration */}
                        <Grid item xs={12} md={3}>
                          <Autocomplete
                            options={duration || []}
                            disabled={!isEditMode}
                            getOptionLabel={(opt) => opt.label || ""}
                            value={
                              duration.find(
                                (d) => d.value === primaryPain.duration
                              ) || null
                            }
                            onChange={(e, val) => {
                              setPrimaryPain(prev => ({
                                ...prev,
                                duration: val?.value || "",
                                pain_days: val?.value === "0 - 1 m" ? prev.pain_days : "" // Clear pain_days if not "1 m"
                              }))
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Duration" size="small" 
                              inputProps={{
                                ...params.inputProps,
                                readOnly: true   // ✅ prevents typing
                              }}
                              error={!!errors.primaryPainDuration}
                              helperText={errors.primaryPainDuration}
                              />
                            )}
                          />
                        </Grid>

                        {/* Pain Days - Only show when duration is "1 m" */}
                        {primaryPain.duration === "0 - 1 m" && (
                          <Grid item xs={12} md={3}>
                            <Autocomplete
                              options={painDays || []}
                              disabled={!isEditMode}
                              getOptionLabel={(opt) => opt.label || ""}
                              value={
                                painDays.find(
                                  (d) => d.value === primaryPain.pain_days
                                ) || null
                              }
                              onChange={(e, val) =>
                                setPrimaryPain(prev => ({
                                  ...prev,
                                  pain_days: val?.value || ""
                                }))
                              }
                              renderInput={(params) => (
                                <TextField {...params} 
                                inputProps={{
                                  ...params.inputProps,
                                  readOnly: true   // ✅ prevents typing
                                }}
                                label="Pain Days" size="small" 
                                />
                              )}
                            />
                          </Grid>
                        )}
    
                        {/* Pain Score */}
                        <Grid item xs={12} md={3}>
                          <Autocomplete
                            options={painScore || []}
                            disabled={!isEditMode}
                            getOptionLabel={(opt) => opt.label?.toString() || ""}
                            value={
                              painScore.find(
                                (p) => p.value === primaryPain.pain_score
                              ) || null
                            }
                            onChange={(e, val) =>
                              setPrimaryPain(prev => ({
                                ...prev,
                                pain_score: val?.value || ""
                              }))
                            }
                            renderInput={(params) => (
                              <TextField {...params} label="Pain Score" size="small"
                              inputProps={{
                                ...params.inputProps,
                                readOnly: true   // ✅ prevents typing
                              }}
                              error={!!errors.primaryPainScore}
                              helperText={errors.primaryPainScore} 
                              />
                            )}
                          />
                        </Grid>
                          {/* ✅ ERROR MESSAGE GOES HERE */}
                        {errors.primaryPainSide && (
                          <Grid item xs={12}>
                            <Typography color="error" fontSize={12}>
                              {errors.primaryPainSide}
                            </Typography>
                          </Grid>
                        )}
    
                      </Grid>
                      
                      {/* Primary Pain Site Validation Error */}
                      {errors?.primary_pain_site && (
                        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                          {errors.primary_pain_site}
                        </Typography>
                      )}
    
                      </>
    
    
                      {/* END PRIMARY */}
                    


                    {/* End Primary Pain */}
                    

                    

          </Typography>
          {/* 2 */}
          <Typography color='text.secondary'>
                <Box mb={2}>
                  <Typography fontWeight={600}>Secondary Pain </Typography>
                  <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                </Box>
                <Grid container spacing={3}>

                  {/* LEFT SIDE – TABLE */}
                  <Grid item xs={12} md={8.5}>

                    <TableContainer component={Paper} sx={{ border: '1px solid #e5e7eb' }}>
                      <Table>

                        <TableHead sx={{ backgroundColor: '#e9efff' }}>
                          <TableRow>
                            <TableCell sx={{ width: 80 }}><b>Pain Site</b></TableCell>
                            <TableCell sx={{ width: 80 }} align='center'><b>Left</b></TableCell>
                            <TableCell sx={{ width: 80 }} align='center'><b>Right</b></TableCell>
                            <TableCell sx={{ width: 290 }}><b>Duration</b></TableCell>
                            <TableCell sx={{ width: 100 }}><b>Pain Score</b></TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {ComplaintSite.map((item, index) => (
                            <>
                            { (item.name !== primaryPain?.pain_site) ? 

                              <TableRow key={index} sx={{
                                backgroundColor: item.error ? "#fff1f0" : "inherit"
                              }}>

                                {/* Pain Site */}
                                <TableCell>{item.name}</TableCell>

                                {/* Left / Right or Center */}
                                {item?.disablelr ? (
                                  <TableCell colSpan={2} align='center'>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={item.center}
                                          onChange={(e) =>
                                            updateComplaint(index, 'center', e.target.checked)
                                          }
                                        />
                                      }
                                      label='Center'
                                    />
                                  </TableCell>
                                ) : (
                                  <>
                                    <TableCell align='center'>
                                      <Checkbox
                                        checked={item.left}
                                        onChange={(e) =>
                                          updateComplaint(index, 'left', e.target.checked)
                                        }
                                      />
                                    </TableCell>

                                    <TableCell align='center'>
                                      <Checkbox
                                        checked={item.right}
                                        onChange={(e) =>
                                          updateComplaint(index, 'right', e.target.checked)
                                        }
                                      />
                                    </TableCell>
                                  </>
                                )}

                                {/* Duration */}
                                <TableCell>
                                  <Autocomplete
                                    options={duration || []}
                                    disabled={!isEditMode}
                                    getOptionLabel={(opt) => opt.label || opt.title || opt.value || ''}
                                    value={duration.find((d) => d.value === item.duration) || null}
                                    onChange={(e, val) => {
                                      updateComplaint(index, 'duration', val?.value || '');
                                      // Clear pain_days if duration is not "1 m"
                                      if (val?.value !== "1 m") {
                                        updateComplaint(index, 'pain_days', '');
                                      }
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select..."
                                        size="small"
                                        inputProps={{
                                          ...params.inputProps,
                                          readOnly: true   // ✅ prevents typing
                                        }}
                                        error={item.error && !item.duration}
                                        helperText={
                                          item.error && !item.duration
                                            ? "Duration required"
                                            : ""
                                        }
                                      />
                                    )}
                                  />
                                  {/* <Autocomplete
                                    options={duration || []}
                                    getOptionLabel={(opt) => opt.label || opt.title || opt.value || ''}
                                    value={duration.find((d) => d.value === item.duration) || null}
                                    onChange={(e, val) =>
                                      updateComplaint(index, 'duration', val?.value || '')
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} placeholder='Select...' size='small' />
                                    )}
                                  /> */}
                                </TableCell>

                                {/* Pain Score */}
                                <TableCell>
                                  <Autocomplete
                                    options={painScore || []}
                                    disabled={!isEditMode}
                                    getOptionLabel={(opt) => opt.label || opt.title || opt.value || ''}
                                    value={painScore.find((p) => p.value === item.painScore) || null}
                                    onChange={(e, val) =>
                                      updateComplaint(index, 'painScore', val?.value || '')
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select..."
                                        size="small"
                                        inputProps={{
                                          ...params.inputProps,
                                          readOnly: true   // ✅ prevents typing
                                        }}
                                        error={item.error && !item.painScore}
                                        helperText={
                                          item.error && !item.painScore
                                            ? "Pain score required"
                                            : ""
                                        }
                                        FormHelperTextProps={{
                                          sx: { minHeight: 20 } // optional UI stability
                                        }}
                                      />
                                    )}
                                  />
                                  {/* <Autocomplete
                                    options={painScore || []}
                                    getOptionLabel={(opt) => opt.label || opt.title || opt.value || ''}
                                    value={painScore.find((p) => p.value === item.painScore) || null}
                                    onChange={(e, val) =>
                                      updateComplaint(index, 'painScore', val?.value || '')
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} placeholder='Select...' size='small' />
                                    )}
                                  /> */}
                                </TableCell>

                              </TableRow>
                            : null}
                            </>
                            
                          ))}
                          <TableCell colSpan={4} align='center'>
                              <TextField
                                fullWidth
                                label='Other Pain Site'
                                value={paf?.other_pain_site || ''}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  
                                  handleInputData('paf', 'other_pain_site', val);
                                  
                                }}
                                
                              />
                            </TableCell>
                        </TableBody>
                      </Table>
                    </TableContainer>

                  </Grid>

                  {/* RIGHT SIDE – BODY IMAGE */}
                  <Grid item xs={12} md={3.5}>
                    <Box position='relative'>

                      <img
                        src='/body.webp'
                        alt='body'
                        style={{ width: '100%', height: 'auto' }}
                      />

                      {/* Head */}
                      <div className={`zone head_pain_left ${activeZones.includes('head_pain_left') ? 'active' : ''}`} />
                      <div className={`zone head_pain_right ${activeZones.includes('head_pain_right') ? 'active' : ''}`} />

                      {/* Neck */}
                      <div className={`zone neck_pain_left ${activeZones.includes('neck_pain_left') ? 'active' : ''}`} />
                      <div className={`zone neck_pain_right ${activeZones.includes('neck_pain_right') ? 'active' : ''}`} />

                      {/* Shoulder */}
                      <div className={`zone shoulder_pain_left ${activeZones.includes('shoulder_pain_left') ? 'active' : ''}`} />
                      <div className={`zone shoulder_pain_right ${activeZones.includes('shoulder_pain_right') ? 'active' : ''}`} />

                      {/* Back (center) */}
                      <div className={`zone back_pain_center ${activeZones.includes('back_pain_center') ? 'active' : ''}`} />

                      {/* Elbow */}
                      <div className={`zone elbow_pain_left ${activeZones.includes('elbow_pain_left') ? 'active' : ''}`} />
                      <div className={`zone elbow_pain_right ${activeZones.includes('elbow_pain_right') ? 'active' : ''}`} />

                      {/* Wrist */}
                      <div className={`zone wrist_pain_left ${activeZones.includes('wrist_pain_left') ? 'active' : ''}`} />
                      <div className={`zone wrist_pain_right ${activeZones.includes('wrist_pain_right') ? 'active' : ''}`} />

                      {/* Palm */}
                      <div className={`zone palm_pain_left ${activeZones.includes('palm_pain_left') ? 'active' : ''}`} />
                      <div className={`zone palm_pain_right ${activeZones.includes('palm_pain_right') ? 'active' : ''}`} />

                      {/* Hip */}
                      <div className={`zone hip_pain_left ${activeZones.includes('hip_pain_left') ? 'active' : ''}`} />
                      <div className={`zone hip_pain_right ${activeZones.includes('hip_pain_right') ? 'active' : ''}`} />

                      {/* Knee */}
                      <div className={`zone knee_pain_left ${activeZones.includes('knee_pain_left') ? 'active' : ''}`} />
                      <div className={`zone knee_pain_right ${activeZones.includes('knee_pain_right') ? 'active' : ''}`} />

                      {/* Ankle */}
                      <div className={`zone ankle_pain_left ${activeZones.includes('ankle_pain_left') ? 'active' : ''}`} />
                      <div className={`zone ankle_pain_right ${activeZones.includes('ankle_pain_right') ? 'active' : ''}`} />

                      {/* Foot */}
                      <div className={`zone foot_pain_left ${activeZones.includes('foot_pain_left') ? 'active' : ''}`} />
                      <div className={`zone foot_pain_right ${activeZones.includes('foot_pain_right') ? 'active' : ''}`} />

                      {/* Heel */}
                      <div className={`zone heel_pain_left ${activeZones.includes('heel_pain_left') ? 'active' : ''}`} />
                      <div className={`zone heel_pain_right ${activeZones.includes('heel_pain_right') ? 'active' : ''}`} />

                    </Box>
                  </Grid>

                  </Grid>
          </Typography>
          {/* 3 */}
          <Typography color='text.secondary'>

                {/* ================= ONSET SECTION ================= */}
                <Box mt={5} mb={2}>
                  <Typography fontWeight={600}>Onset</Typography>
                  <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                </Box>
                <Grid container spacing={4}>
                {/* Onset Type */}
                <Grid item xs={12} md={4}>
                  <Typography fontWeight={600} mb={1}>Onset Type</Typography>

                  <RadioGroup
                    row
                    value={onset.onsetType}
                    onChange={(e) =>
                      setOnset({ ...onset, onsetType: e.target.value })
                    }
                  >
                    {['Sudden', 'Insidious'].map((opt) => (
                      <FormControlLabel
                        key={opt}
                        value={opt}
                        control={<Radio />}
                        label={opt}
                      />
                    ))}
                  </RadioGroup>
                </Grid>

                {/* Progress Type */}
                <Grid item xs={12} md={4}>
                  <Typography fontWeight={600} mb={1}>Progress</Typography>

                  <RadioGroup
                    row
                    value={onset.progressType}
                    onChange={(e) =>
                      setOnset({ ...onset, progressType: e.target.value })
                    }
                  >
                    {['Non-Progressive', 'Progressive'].map((opt) => (
                      <FormControlLabel
                        key={opt}
                        value={opt}
                        control={<Radio />}
                        label={opt}
                      />
                    ))}
                  </RadioGroup>
                </Grid>

                {/* Progress Speed (only if Progressive) */}
                {onset.progressType === 'Progressive' && (
                  <Grid item xs={12} md={4}>
                    <Typography fontWeight={600} mb={1}>Progress Speed <span style={{color:"red"}}>*</span></Typography>

                    <RadioGroup
                      row
                      value={onset.progressSpeed}
                      onChange={(e) =>
                        setOnset({ ...onset, progressSpeed: e.target.value })
                      }
                    >
                      {['Rapid', 'Slow'].map((opt) => (
                        <FormControlLabel
                          key={opt}
                          value={opt}
                          control={<Radio />}
                          label={opt}
                        />
                      ))}
                    </RadioGroup>
                    {errors.progressSpeed && (
                      <Typography color="error" fontSize={12}>
                        {errors.progressSpeed}
                      </Typography>
                    )}
                  </Grid>
                )}
                </Grid>
                {/* ================= CHARACTER SECTION ================= */}
                {/* <Grid item xs={12}>
                  <Typography variant='h6' fontWeight={600}>
                    Character
                  </Typography>
                </Grid> */}
                <Box mt={5} mb={2}>
                  <Typography fontWeight={600}>Character</Typography>
                  <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                </Box>
                <Grid container >
                {[
                  'Numbness',
                  'Tingling',
                  'Needles',
                  'Pain with mild pressure',
                  'Current like pain',
                  'Burning',
                  'Throbbing'
                ].map((opt) => (
                  <Grid item xs={12} sm={6} md={2} key={opt}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={character.includes(opt)}
                          onChange={() =>
                            setCharacter((prev) =>
                              prev.includes(opt)
                                ? prev.filter((x) => x !== opt)
                                : [...prev, opt]
                            )
                          }
                        />
                      }
                      label={opt}
                    />
                  </Grid>
                   
                ))}
              </Grid>
             
          </Typography>
          {/* 4 */}
          <Typography color='text.secondary'>
              
              {/* ================= ASSOCIATED COMPLAINTS ================= */}
              <Box mt={5} mb={2}>
                  <Typography fontWeight={600}>Associated Complaints</Typography>
                  <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
              </Box>
              <Grid container spacing={4}>

              {['Vomiting', 'Headache'].map((opt) => (
                <Grid item xs={12} sm={6} md={2} key={opt}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={associatedComplaints.includes(opt)}
                        onChange={() =>
                          setAssociatedComplaints((prev) =>
                            prev.includes(opt)
                              ? prev.filter((x) => x !== opt)
                              : [...prev, opt]
                          )
                        }
                      />
                    }
                    label={opt}
                  />
                </Grid>
              ))}

              </Grid>
              {/* ================= RADIATION / REFERRAL ================= */}
              
              <Box mt={5} mb={2}>
                  <Typography fontWeight={600}>Radiation / Referral</Typography>
                  <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
              </Box>
              <Grid container spacing={4}>

              {/* Radiation Section */}
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={radiationReferral.radiation.selected}
                      onChange={(e) =>
                        setRadiationReferral((prev) => ({
                          ...prev,
                          radiation: {
                            ...prev.radiation,
                            selected: e.target.checked,
                            text: e.target.checked ? prev.radiation.text : '',
                          },
                        }))
                      }
                    />
                  }
                  label='Radiation'
                />

                {radiationReferral.radiation.selected && (
                  <TextField
                    fullWidth
                    size='small'
                    sx={{ mt: 1 }}
                    label='Radiation Details'
                    placeholder='Enter radiation details'
                    value={radiationReferral.radiation.text}
                    error={!!errors.radiation_text}
                    helperText={errors.radiation_text}
                    onChange={(e) =>
                      setRadiationReferral((prev) => ({
                        ...prev,
                        radiation: {
                          ...prev.radiation,
                          text: e.target.value,
                        },
                      }))
                    }
                  />
                )}
              </Grid>

              {/* Referral Section */}
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={radiationReferral.referral.selected}
                      onChange={(e) =>
                        setRadiationReferral((prev) => ({
                          ...prev,
                          referral: {
                            ...prev.referral,
                            selected: e.target.checked,
                            text: e.target.checked ? prev.referral.text : '',
                          },
                        }))
                      }
                    />
                  }
                  label='Referral'
                />

                {radiationReferral.referral.selected && (
                  <TextField
                    fullWidth
                    size='small'
                    sx={{ mt: 1 }}
                    label='Referral Details'
                    placeholder='Enter referral details'
                    value={radiationReferral.referral.text}
                    error={!!errors.referral_text}
                    helperText={errors.referral_text}
                    onChange={(e) =>
                      setRadiationReferral((prev) => ({
                        ...prev,
                        referral: {
                          ...prev.referral,
                          text: e.target.value,
                        },
                      }))
                    }
                  />
                )}
              </Grid>

            </Grid>
          </Typography>
          {/* 5 */}
          <Typography color='text.secondary'>
              {/* ================= HEALTH CONDITIONS ================= */}
             
              <Box mt={5} mb={2}>
                  <Typography fontWeight={600}>Health Conditions</Typography>
                  <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
              </Box>
              <Grid container spacing={3}>

              {[
                'Diabetes Mellitus',
                'Hypothyroidism',
                'Hypertension',
                'Cardiac Illness',
                'Bronchial Asthma',
                'Previous Surgery',
                'Bleeding Disorder',
                'Kidney Disease',
                'Liver Disease',
                'Neurological Conditions',
                'Cancer (Past / Present)',
                'Auto Immune Disorders',
                'None',
                'Others',
              ].map((opt) => {
                  const isNoneSelected = healthConditions.includes('None');
                  return (
                    <Grid item xs={12} sm={6} md={3} key={opt}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={healthConditions.includes(opt)}
  
                            disabled={opt !== 'None' && isNoneSelected}
                            
                            onChange={() => {
                              if (opt === 'None') {
                                // If None clicked → clear all and select None
                                setHealthConditions(
                                  healthConditions.includes('None') ? [] : ['None']
                                );
                              } else {
                                setHealthConditions((prev) => {
                                  let updated = prev.includes(opt)
                                    ? prev.filter((x) => x !== opt)
                                    : [...prev.filter((x) => x !== 'None'), opt];
  
                                  return updated;
                                });
                              }
                            }}
                          />
                        }
                        label={opt}
                      />
                    </Grid>
                  )
              })}

              {/* Others Text Field */}
              {healthConditions.includes('Others') && (
                <Grid item xs={12} sm={12} md={4}>
                  <TextField
                    fullWidth
                    size='small'
                    label='Other Health Conditions'
                    placeholder='Enter other health conditions'
                    value={healthConditionsOther}
                    onChange={(e) => setHealthConditionsOther(e.target.value)}
                  />
                </Grid>
              )}

              </Grid>
          </Typography>
          {/* 6 */}
          <Typography color='text.secondary'>
            

            {/* ================= PAST REPORTS ================= */}
            <Box mt={5} mb={2}>
                <Typography fontWeight={600}>
                  Past Reports <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
            </Box>
            
            <Grid container spacing={3}>
            {/* None Checkbox */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={pastReports.includes('None')}
                    onChange={() => {
                      setPastReports((prev) => {
                        if (prev.includes('None')) {
                          // Uncheck "None"
                          return prev.filter((x) => x !== 'None');
                        } else {
                          // Check "None" and clear all others
                          setPastReportsOther('');
                          // Clear validation error
                          setErrors((prevErrors) => {
                            const { past_reports, ...rest } = prevErrors;
                            return rest;
                          });
                          return ['None'];
                        }
                      });
                    }}
                  />
                }
                label='None'
              />
            </Grid>

            {/* Past Reports Multi Options */}
            {['X-Ray', 'MRI', 'CT', 'USG', 'Others'].map((opt) => (
              <Grid item xs={12} sm={6} md={2} key={opt}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={pastReports.includes('None')}
                      checked={pastReports.includes(opt)}
                      onChange={() => {
                        setPastReports((prev) => {
                          // Clear validation error
                          setErrors((prevErrors) => {
                            const { past_reports, ...rest } = prevErrors;
                            return rest;
                          });
                          
                          if (prev.includes(opt)) {
                            // Uncheck the option
                            return prev.filter((x) => x !== opt);
                          } else {
                            // Check the option and remove "None" if present
                            return [...prev.filter((x) => x !== 'None'), opt];
                          }
                        });
                      }}
                    />
                  }
                  label={opt}
                />
              </Grid>
            ))}

            {/* Other Past Reports */}
            {pastReports.includes('Others') && (
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  size='small'
                  label='Other Reports'
                  placeholder='Enter other reports'
                  value={pastReportsOther}
                  onChange={(e) => setPastReportsOther(e.target.value)}
                />
              </Grid>
            )}

            </Grid>
            
            {/* Past Reports Validation Error */}
            {errors?.past_reports && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {errors.past_reports}
              </Typography>
            )}
            {/* ================= ALLERGIES ================= */}
            
            <Box mt={3} mb={2}>
                <Typography fontWeight={600}>Allergies</Typography>
                <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
            </Box>
            <Grid container spacing={3}>
            {/* None Checkbox */}
            <Grid item xs={12} sm={6} md={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={allergies.none}
                    onChange={() => {
                      allergies.none === true
                        ? setAllergies({ multi: [], none: false, otherText: '' })
                        : setAllergies({ multi: [], none: true, otherText: '' });
                    }}
                  />
                }
                label='None'
              />
            </Grid>

            {/* Allergy Multi Options */}
            {['Any known Drug Allergies', 'Xylocaine / Lignocaine', 'Others'].map((opt) => (
              <Grid item xs={12} sm={6} md={3} key={opt}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={allergies.none}
                      checked={allergies.multi.includes(opt)}
                      onChange={() =>
                        setAllergies((prev) => ({
                          ...prev,
                          multi: prev.multi.includes(opt)
                            ? prev.multi.filter((x) => x !== opt)
                            : [...prev.multi, opt],
                        }))
                      }
                    />
                  }
                  label={opt}
                />
              </Grid>
            ))}

            {/* Other Allergies */}
            {allergies.multi.includes('Others') && (
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  size='small'
                  label='Other Allergies'
                  placeholder='Enter other allergies'
                  value={allergies.otherText}
                  onChange={(e) =>
                    setAllergies({ ...allergies, otherText: e.target.value })
                  }
                />
              </Grid>
            )}

            </Grid>
          </Typography>
          {/* 7 */}
          <Box>
            
            {/* ================= HEADER ================= */}
            <Box mb={3}>
              <Typography  fontWeight={600}>
                Pain Triggers & Relievers
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                Mark (+) if it increases pain, (–) if it reduces pain
              </Typography>
              <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
            </Box>
      
            {/* ================= FACTOR LIST ================= */}
            <Box>
              {[...factorsList1, ...factorsList2].map((factor) => (
                <PainFactorRow
                  key={factor}
                  label={factor}
                  value={painFactors[factor] || ''}
                  onChange={(val) =>
                    setPainFactors((prev) => ({
                      ...prev,
                      [factor]: val,
                    }))
                  }
                />
              ))}
            </Box>
      
            {/* ================= OTHERS ================= */}
            <Box mt={3}>
              <Typography fontWeight={600}>Others</Typography>
              <TextField
                fullWidth
                size='small'
                sx={{ mt: 1, maxWidth: 400 }}
                placeholder='Enter other triggers / relievers'
                value={painFactorsOther}
                onChange={(e) => setPainFactorsOther(e.target.value)}
              />
            </Box>
      
          </Box>
          {/* 8 */}
          <Box mt={3} mb={1}>
                <Typography fontWeight={600}>Medication History</Typography>
                <Typography variant='body2' color='text.secondary'>
                  (Past 1 month / Others)
                </Typography>
                <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
              </Box>
              <Grid container >
              {/* Anticoagulants */}
              <Grid item xs={12} sm={6} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={medicationHistory.anticoagulants}
                      onChange={(e) =>
                        setMedicationHistory((prev) => ({
                          ...prev,
                          anticoagulants: e.target.checked,
                        }))
                      }
                    />
                  }
                  label='Anticoagulants'
                />
              </Grid>

              {/* Steroids */}
              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={medicationHistory.steroids}
                      onChange={(e) =>
                        setMedicationHistory((prev) => ({
                          ...prev,
                          steroids: e.target.checked,
                        }))
                      }
                    />
                  }
                  label='Steroid Intake (any route)'
                />
              </Grid>

              {/* Others Checkbox */}
              <Grid item xs={12} sm={6} md={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={medicationHistory.othersSelected}
                      onChange={(e) =>
                        setMedicationHistory((prev) => ({
                          ...prev,
                          othersSelected: e.target.checked,
                          othersText: e.target.checked ? prev.othersText : '',
                        }))
                      }
                    />
                  }
                  label='Others'
                />
              </Grid>

              {/* Other Medications Text */}
              {medicationHistory.othersSelected && (
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    size='small'
                    label='Other Medications'
                    placeholder='Enter other medications'
                    value={medicationHistory.othersText}
                    onChange={(e) =>
                      setMedicationHistory((prev) => ({
                        ...prev,
                        othersText: e.target.value,
                      }))
                    }
                  />
                </Grid>
              )}
              </Grid>
              {/* ================= FAMILY HISTORY ================= */}
              
                            <Box mt={3} mb={2}>
                              <Typography fontWeight={600}>Family History of Similar Pain</Typography>
                              <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
                            </Box>
              
                            <Grid container spacing={2}>
              
                              {/* Yes / No Radio */}
                              <Grid item xs={12}>
                                <RadioGroup
                                  row
                                  value={familyHistory?.hasHistory}
                                  onChange={(e) =>
                                    setFamilyHistory({
                                      hasHistory: e.target.value,
                                      details: e.target.value === "yes"
                                        ? familyHistory.details
                                        : ""
                                    })
                                  }
                                >
                                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                  <FormControlLabel value="no" control={<Radio />} label="No" />
                                </RadioGroup>
                              </Grid>
              
                              {/* Text field only if Yes */}
                              {familyHistory.hasHistory === "yes" && (
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    multiline
                                    minRows={2}
                                    size="small"
                                    label="Family History Details"
                                    placeholder="Enter family history"
                                    value={familyHistory?.details}
                                    onChange={(e) =>
                                      setFamilyHistory(prev => ({
                                        ...prev,
                                        details: e.target.value
                                      }))
                                    }
                                  />
                                </Grid>
                              )}
              
                            </Grid>
              
              {/* <Box mt={3} mb={2}>
                <Typography fontWeight={600}>Family History</Typography>
                <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
              </Box>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  size='small'
                  label='Family History'
                  placeholder='Enter family history'
                  value={familyHistory}
                  onChange={(e) => setFamilyHistory(e.target.value)}
                />
              </Grid> */}
              {/* 9 */}
              <Typography color='text.secondary'>

              {/* ================= TITLE ================= */}
             
              <Box mt={3} mb={1}>
                <Typography fontWeight={600}>
                  Past Treatments <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Box sx={{ height: 2, width: '100%', background: '#e5e7eb', mt: 1 }} />
              </Box>
              <Grid container spacing={1}>

              {/* ================= NONE ================= */}
              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={pastTreatments.none}
                      onChange={(e) => {
                        if (e.target.checked) {
                          // When None is checked, clear all other selections
                          setPastTreatments({
                            none: true,
                            pms: { selected: false, option: "" },
                            physio: false,
                            otc: false,
                            surgeon: { selected: false, option: "" },
                            physician: false,
                            altTreatments: false
                          });
                          // Clear validation error
                          setErrors((prevErrors) => {
                            const { past_treatments, ...rest } = prevErrors;
                            return rest;
                          });
                        } else {
                          // When None is unchecked
                          setPastTreatments((prev) => ({
                            ...prev,
                            none: false
                          }));
                        }
                      }}
                    />
                  }
                  label='None'
                />
              </Grid>

              {/* ================= PMS ================= */}
              <Grid item xs={12} sm={6} md={4}>
                {/* <FormControlLabel
                  control={
                    <Checkbox
                      checked={pastTreatments.pms.consulted}
                      onChange={(e) =>
                        setPastTreatments((prev) => ({
                          ...prev,
                          pms: { ...prev.pms, consulted: e.target.checked },
                        }))
                      }
                    />
                  }
                  label='PMS – Consulted'
                /> */}
                <FormControlLabel
                    control={
                      <Checkbox
                        disabled={pastTreatments.none}
                        checked={pastTreatments.pms.selected}
                        onChange={(e) => {
                          setPastTreatments(prev => ({
                            ...prev,
                            none: false,
                            pms: {
                              ...prev.pms,
                              selected: e.target.checked,
                              option: e.target.checked ? prev.pms.option : ""
                            }
                          }));
                          // Clear validation error
                          setErrors((prevErrors) => {
                            const { past_treatments, ...rest } = prevErrors;
                            return rest;
                          });
                        }}
                      />
                    }
                    label="PMS"
                  />
              </Grid>
              {pastTreatments.pms.selected && (
                  <Grid item xs={12} sx={{ pl: 4 }}>
                    <Typography fontWeight={600} mb={1}>
                      PMS Details
                    </Typography>
  
                    <RadioGroup
                      row
                      value={pastTreatments.pms.option}
                      onChange={(e) =>
                        setPastTreatments(prev => ({
                          ...prev,
                          pms: {
                            ...prev.pms,
                            option: e.target.value
                          }
                        }))
                      }
                    >
                      {["Procedure Prescribed", "Procedure not prescribed", "Procedure Taken"].map(opt => (
                        <FormControlLabel
                          key={opt}
                          value={opt}
                          control={<Radio />}
                          label={opt}
                        />
                      ))}
                    </RadioGroup>
                  </Grid>
                )}

              {/* <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={pastTreatments.pms.procedure}
                      onChange={(e) =>
                        setPastTreatments((prev) => ({
                          ...prev,
                          pms: { ...prev.pms, procedure: e.target.checked },
                        }))
                      }
                    />
                  }
                  label='PMS – Procedure Taken'
                />
              </Grid> */}

              {/* ================= PHYSIO ================= */}
              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={pastTreatments.none}
                      checked={pastTreatments.physio}
                      onChange={(e) => {
                        setPastTreatments((prev) => ({
                          ...prev,
                          none: false,
                          physio: e.target.checked,
                        }));
                        // Clear validation error
                        setErrors((prevErrors) => {
                          const { past_treatments, ...rest } = prevErrors;
                          return rest;
                        });
                      }}
                    />
                  }
                  label='Physiotherapy'
                />
              </Grid>

              {/* ================= OTC DRUGS ================= */}
              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={pastTreatments.none}
                      checked={pastTreatments.otc}
                      onChange={(e) => {
                        setPastTreatments((prev) => ({
                          ...prev,
                          none: false,
                          otc: e.target.checked,
                        }));
                        // Clear validation error
                        setErrors((prevErrors) => {
                          const { past_treatments, ...rest } = prevErrors;
                          return rest;
                        });
                      }}
                    />
                  }
                  label='OTC Drugs'
                />
              </Grid>

              {/* ================= SURGEON ================= */}
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={pastTreatments.none}
                      checked={pastTreatments.surgeon.selected}
                      onChange={(e) => {
                        setPastTreatments((prev) => ({
                          ...prev,
                          none: false,
                          surgeon: {
                            ...prev.surgeon,
                            selected: e.target.checked,
                            option: e.target.checked ? prev.surgeon.option : '',
                          },
                        }));
                        // Clear validation error
                        setErrors((prevErrors) => {
                          const { past_treatments, ...rest } = prevErrors;
                          return rest;
                        });
                      }}
                    />
                  }
                  label='Surgeon'
                />
              </Grid>

              {/* Surgeon Options (Only when selected) */}
              {pastTreatments.surgeon.selected && (
                <Grid item xs={12} sx={{ pl: 4 }}>
                  <Typography fontWeight={600} mb={1}>
                    Surgeon Details
                  </Typography>

                  <RadioGroup
                    row
                    value={pastTreatments.surgeon.option}
                    onChange={(e) =>
                      setPastTreatments((prev) => ({
                        ...prev,
                        surgeon: { ...prev.surgeon, option: e.target.value },
                      }))
                    }
                  >
                    {['Sx Prescribed', 'Sx not Prescribed', 'Sx Done'].map((opt) => (
                      <FormControlLabel
                        key={opt}
                        value={opt}
                        control={<Radio />}
                        label={opt}
                      />
                    ))}
                  </RadioGroup>
                </Grid>
              )}

              {/* ================= GEN PHYSICIAN ================= */}
              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={pastTreatments.none}
                      checked={pastTreatments.physician}
                      onChange={(e) => {
                        setPastTreatments((prev) => ({
                          ...prev,
                          none: false,
                          physician: e.target.checked,
                        }));
                        // Clear validation error
                        setErrors((prevErrors) => {
                          const { past_treatments, ...rest } = prevErrors;
                          return rest;
                        });
                      }}
                    />
                  }
                  label='General Physician'
                />
              </Grid>

              {/* ================= ALT TREATMENTS ================= */}
              <Grid item xs={12} sm={6} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={pastTreatments.none}
                      checked={pastTreatments.altTreatments}
                      onChange={(e) => {
                        setPastTreatments((prev) => ({
                          ...prev,
                          none: false,
                          altTreatments: e.target.checked,
                        }));
                        // Clear validation error
                        setErrors((prevErrors) => {
                          const { past_treatments, ...rest } = prevErrors;
                          return rest;
                        });
                      }}
                    />
                  }
                  label='Alternative Treatments'
                />
              </Grid>

              </Grid>
              
              {/* Past Treatments Validation Error */}
              {errors?.past_treatments && (
                <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                  {errors.past_treatments}
                </Typography>
              )}
          </Typography>


          </>
        );
        default:
          return null;
      }
    };


    // CODE WHICH IS RETURN
    return (
      <div className=''>
        <form>
          <Box sx={{ minHeight: '100vh', background: '#f4f6f9', p: 4 }}>
            <Card
              sx={{
                maxWidth: 1300,
                mx: 'auto',
                borderRadius: 3,
                boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
              }}
            >
              <CardContent sx={{ p: 4 }}>
    
                {/* ===== HEADER WITH EDIT BUTTON ===== */}
                <Box display='flex' justifyContent='space-between' alignItems='center' mb={3}>
                  <Typography variant='h6' fontWeight={600}>
                  {isEditMode ? steps[currentStep] : "Review your PAF"}
                  </Typography>
    
                  <Box display="flex" gap={2} alignItems="center">
    
                    {(pafStatus === 0 || pafStatus === 1) && !isEditMode && !userData?.read_only && (
                      <Button
                        variant="contained"
                        color="warning"
                        onClick={() => setIsEditMode(true)}
                      >
                        Edit
                      </Button>
                    )}
                    {isEditMode && (
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => setIsEditMode(false)}
                      >
                        Cancel
                      </Button>
                    )}
                    {!pafStatus && !isEditMode ? 
                    <Button
                    variant="contained"
                    color="primary"
                    disabled={isEditMode}
                    onClick={() => {
                      console.log(pid)
                      // console.log("link");
                      let windoConfirm = window.confirm('Are you sure you want to Link to next prescription?');
                      if (windoConfirm) {
                        pafUpdateStatus(pid);
                      }
                    }}
                  >
                    Link to next prescription
                  </Button>: null

                    }
                        
    
                    {/* <Chip
                      label={`Step ${currentStep + 1} of ${steps.length}`}
                      color='primary'
                      variant='outlined'
                    /> */}
    
                  </Box>
                </Box>
    
                {/* Progress */}
                <Box mb={3}>
                  <LinearProgress
                    variant='determinate'
                    value={((currentStep + 1) / steps.length) * 100}
                    sx={{ height: 10, borderRadius: 5 }}
                  />
                </Box>
    
                {/* ===== FREEZE FORM HERE ===== */}
                <fieldset
                  disabled={!isEditMode}
                  style={{
                    border: "none",
                    padding: 0,
                    margin: 0,
                    opacity: isEditMode ? 1 : 0.9
                  }}
                >
    
                  {/* Step Content */}
                  <Box minHeight={300}>
                    {renderStepContent(currentStep)}
                  </Box>
    
                  {/* Footer Navigation */}
                  <Box display='flex' justifyContent='space-between' mt={5}>
                    <Button
                      variant='outlined'
                      disabled={currentStep === 0}
                      onClick={handleBack}
                    >
                      Back
                    </Button>
    
                    {currentStep < steps.length - 1 ? (
                      <Button variant='contained' onClick={handleNext}>
                        Next
                      </Button>
                    ) 
                    :(
                      <>
                      {(pafStatus === 0 || pafStatus === 1) && 
                        <Button
                          variant="contained"
                          color="success"
                          disabled={!isEditMode}
                          onClick={() => {
      
                            if (!isEditMode) return;
      
                            setFieldErrors([]);
      
                            if (!validateBeforeSave()) {
                              alert("Fill all mandatory fields");
                              return;
                            }
      
                            const saveData = {
                              paf,
                              complaint_site: ComplaintSite,
                              onset,
                              radiation_referral: radiationReferral,
                              character_data: character,
                              associated_complaints: associatedComplaints,
                              health_conditions: healthConditions,
                              health_conditions_other: healthConditionsOther,
                              past_reports: pastReports,
                              past_reports_other: pastReportsOther,
                              allergies,
                              pain_factors_other: painFactorsOther,
                              medication_history: medicationHistory,
                              family_history: familyHistory,
                              past_treatments: pastTreatments,
                              pain_factors: painFactors,
                              is_new: 1,
                              primary_pain: primaryPain,
                            };
      
                            onSave(saveData);
                            setIsEditMode(false);
                          }}
                        >
                          Save Details
                        </Button>
                      }
                      </>
                      
    
                    )}
                  </Box>
    
                </fieldset>
    
              </CardContent>
            </Card>
          </Box>
        </form>
      </div>
    );
    
  };

  return <div className='prescription-form'>{renderFormDetails()}</div>;
}

export default EditPafForm;